import * as React from 'react';

const SvgFaqArrow = (props) => (
  <svg
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.732 20.773a1 1 0 0 0 1.415 0l8.693-8.693a1.648 1.648 0 0 1 2.319 0l8.693 8.693a1 1 0 0 0 1.415-1.414l-8.694-8.693a3.647 3.647 0 0 0-5.147 0l-8.694 8.693a1 1 0 0 0 0 1.414Z'
      fill='var(--fill)'
    />
  </svg>
);

export default SvgFaqArrow;
